import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import Raven from 'raven-js';
import { useState } from 'react';
import { showErrorNotification } from '../utils/notifications';
import { Metrics } from '../utils/metrics';
const FAILED_TO_CALL_ONREADY_KEY = 'Failed to call the onReady on the collaboration sidebar embedded app';
export default function useHandleIFrameError(props) {
  "use memo";

  const $ = _c(12);
  const onContentErrorRef = props && props.onContentErrorRef;
  const appName = props === null || props === void 0 ? void 0 : props.appName;
  const context = (props === null || props === void 0 ? void 0 : props.context) || "sidebar";
  const [IFrameError, setIFrameError] = useState(null);
  let t0;
  if ($[0] !== appName || $[1] !== context || $[2] !== onContentErrorRef) {
    t0 = error => {
      setIFrameError(error);
      if (appName) {
        Metrics.counter("iframe-init-error", {
          app_name: appName,
          context
        }).increment();
      }
      showErrorNotification({
        message: I18n.text("collaborationSidebar.notifications.failure.collaborationSidebar"),
        sticky: true
      });
      if (onContentErrorRef && onContentErrorRef.current) {
        onContentErrorRef.current(error);
      }
    };
    $[0] = appName;
    $[1] = context;
    $[2] = onContentErrorRef;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSidebarInitError = t0;
  let t1;
  if ($[4] !== appName || $[5] !== context || $[6] !== onContentErrorRef) {
    t1 = error_0 => {
      setIFrameError(error_0);
      if (appName) {
        Metrics.counter("iframe-ready-error", {
          app_name: appName,
          context
        }).increment();
      }
      showErrorNotification({
        message: I18n.text("collaborationSidebar.notifications.failure.collaborationSidebar"),
        sticky: true
      });
      Raven.captureException(new Error(FAILED_TO_CALL_ONREADY_KEY, {
        cause: error_0
      }), {
        fingerprint: [FAILED_TO_CALL_ONREADY_KEY]
      });
      if (onContentErrorRef && onContentErrorRef.current) {
        onContentErrorRef.current(error_0);
      }
    };
    $[4] = appName;
    $[5] = context;
    $[6] = onContentErrorRef;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleSidebarReadyError = t1;
  let t2;
  if ($[8] !== IFrameError || $[9] !== handleSidebarInitError || $[10] !== handleSidebarReadyError) {
    t2 = {
      handleSidebarInitError,
      handleSidebarReadyError,
      IFrameError
    };
    $[8] = IFrameError;
    $[9] = handleSidebarInitError;
    $[10] = handleSidebarReadyError;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}